/* eslint-disable */
import { useTranslation } from "react-i18next";
import { Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { getSensorsByQuery } from "components/axios/iotAxios";
import MainCard from "components/MainCard";
import { useEnumApi } from "contexts/EnumApiContext";

const EquipmentSensor = ({info}) => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    const [equipmentSensors, setEquipmentSensors] = useState(null);
    const equipmentSensorList = ()=> {
        if (info) {
            getSensorsByQuery({"equipmentPart.equipment.id":info.id , size:1100, "equipmentPart.deletedYn" :false}).then((res2)=>{
                if (res2 && res2._embedded) {
                    setEquipmentSensors(res2._embedded.sensors);
                } else {
                    setEquipmentSensors(null);
                }
            })
        }
    }

    useEffect(()=>{
        equipmentSensorList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[info]);

    if (info) {
        return (
            <div style={{marginTop:"10px"}}>
                <MainCard style={{marginTop:"10px"}}>
                    <div style={{marginBottom:"10px"}}>
                        <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                        <Chip label={t('message.common.title.sensor.information')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
                    </div>
                    <TableContainer style={{width:"100%"}}>
                        <Table sx={{ minWidth: 500 }} aria-label="simple table" className="list_table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className="th" align="center" style={{width:"40px"}}>No.</TableCell>
                                    <TableCell className="th" align="center">G/W</TableCell>
                                    <TableCell className="th" align="center">Type</TableCell>
                                    <TableCell className="th" align="center">S/N</TableCell>
                                    <TableCell className="th" align="center">BLE MAC</TableCell>
                                    <TableCell className="th" align="center">CAN ID</TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.axis')},{t('message.common.subtitle.radius')},{t('message.common.subtitle.vertical')}</TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.installation.location')} - {t('message.common.subtitle.material')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { equipmentSensors && equipmentSensors.map(function(item, i) {
                                    return (                                        
                                <TableRow key={i}>
                                    <TableCell align="center" style={{width:"40px"}}>{equipmentSensors.length-i}</TableCell>
                                    <TableCell align="center">{item.gateway && item.gateway.sn}</TableCell>
                                    <TableCell align="center">{item.sensorType && getEnumValueByEnumNameAndCode("SensorType", item.sensorType)?.[0]?.title}</TableCell>
                                    <TableCell align="center">{item.sn}</TableCell>
                                    <TableCell align="center">{item.bleMacAdr}</TableCell>
                                    <TableCell align="center">{item.canId}</TableCell>
                                    <TableCell align="center">
                                    {item.sensorType === 'V' ?
                                        <>
                                        {item.axial && getEnumValueByEnumNameAndCode("SensorDirection", item.axial)?.[0]?.title}
                                        {item.radial && ', '+getEnumValueByEnumNameAndCode("SensorDirection", item.radial)?.[0]?.title}
                                        {item.vertical && ', '+getEnumValueByEnumNameAndCode("SensorDirection", item.vertical)?.[0]?.title}
                                        </>
                                    :"-"
                                    }
                                    </TableCell>
                                    <TableCell align="center">{item.equipmentPart.componentLocation?.name} - {item.equipmentPart.masterEquipmentPart.name}</TableCell>
                                </TableRow>
                                    )
                                }) }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </MainCard>
            </div>
        )
    }
}
export default EquipmentSensor;